export default __webpack_public_path__ + "static/spin-the-wheel-campaign-2b1e94a41bd2aa4b9981acb6cb479f15.png";